import '../../httpservices/core/ajax.httpservice.core';

export function printReport(urlToFetchHtml) {
    return $.getHtml(urlToFetchHtml)
        .done(response => {

            let myWindow = window.open(' ', '');
            myWindow.document.write(response);

            setTimeout(() => {
                myWindow.document.close();
                myWindow.focus();
                myWindow.print();
                myWindow.close();
            });
        });
}